import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './tourism.json';

const Tourism = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Travel industry, sustainable tourism, and cultural vocabulary. B2 level grammar, reading, and speaking exercises."
            level="B2"
            title="Tourism"
            image="/Images/budapest-tourism-crowd.webp"
            seoTitle="Free English Lesson Plans: Tourism"
            seoDescription="Travel industry, sustainable tourism, and cultural vocabulary. B2 level grammar, reading, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Tourism;


